"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ToolbarOverflowLayout: true
};
exports.default = exports.ToolbarOverflowLayout = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _constants = require("../utils/constants");
var _Toolbar = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Toolbar.css") : void 0);
var _ToolbarOverflowLayout = require("./_ToolbarOverflowLayout.types");
Object.keys(_ToolbarOverflowLayout).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ToolbarOverflowLayout[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ToolbarOverflowLayout[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const CSS_BLOCK = 'sapcnqr-toolbar';
const ToolbarOverflowLayout = _props => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(ToolbarOverflowLayout, _props)) : _props;
  const {
    startIconOrBadge,
    innerTextClassName,
    centerText,
    toolbarOverflowEnd,
    endIconOrBadge,
    hasLeftIcon,
    setHasLeftIcon,
    hasRightIcon,
    setHasRightIcon
  } = props;
  const classnames = _bind.default.bind(_Toolbar.default);
  const iconCtrClasses = classnames(`${CSS_BLOCK}__overflow-layout-icon-ctr`);
  const hasLeftRightClasses = classnames(`${CSS_BLOCK}__overflow-layout-ctr-left-right`);
  const hasLeftOnlyClasses = classnames(`${CSS_BLOCK}__overflow-layout-ctr-left`);
  const hasRightOnlyClasses = classnames(`${CSS_BLOCK}__overflow-layout-ctr-right`);
  const hasNoLeftRightClasses = classnames(`${CSS_BLOCK}__overflow-layout-ctr`);
  let containerClasses = hasLeftRightClasses;
  if (hasLeftIcon && !hasRightIcon) {
    containerClasses = hasLeftOnlyClasses;
  } else if (!hasLeftIcon && hasRightIcon) {
    containerClasses = hasRightOnlyClasses;
  } else if (!hasLeftIcon && !hasRightIcon) {
    containerClasses = hasNoLeftRightClasses;
  }
  (0, _react.useEffect)(() => {
    if (!centerText) {
      return;
    }
    if (startIconOrBadge) {
      setHasLeftIcon === null || setHasLeftIcon === void 0 ? void 0 : setHasLeftIcon(true);
    }
    if (toolbarOverflowEnd || endIconOrBadge) {
      setHasRightIcon === null || setHasRightIcon === void 0 ? void 0 : setHasRightIcon(true);
    }
  }, [centerText, hasLeftIcon, hasRightIcon, startIconOrBadge, toolbarOverflowEnd, endIconOrBadge, setHasLeftIcon, setHasRightIcon]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: containerClasses
  }, hasLeftIcon && /*#__PURE__*/_react.default.createElement("div", {
    className: iconCtrClasses
  }, startIconOrBadge), /*#__PURE__*/_react.default.createElement("div", {
    className: classnames(_constants.CSS_PREFIX, innerTextClassName, `${CSS_BLOCK}__overflow-layout-text`)
  }, centerText), hasRightIcon && (/*#__PURE__*/_react.default.createElement("div", {
    className: iconCtrClasses
  }, toolbarOverflowEnd || endIconOrBadge)));
};
exports.ToolbarOverflowLayout = ToolbarOverflowLayout;
ToolbarOverflowLayout.displayName = 'ToolbarOverflowLayout';
var _default = exports.default = ToolbarOverflowLayout;